import { isNullOrUndefined } from '../../../predicates/type';
import syncManager from '../../../utils/syncManager';
import { OUTDATED_APP_CSS_ERROR_MESSAGE, OUTDATED_APP_ERROR_MESSAGE, OUTDATED_APP_ERROR_NAME } from './const';
import { OutdatedAppError } from './types';

function isOutdatedAppError(error: typeof PromiseRejectionEvent.prototype) {
	if (isNullOrUndefined(error?.reason)) {
		return;
	}

	const typedReason = error.reason as OutdatedAppError;

	return (
		typedReason.message?.toLowerCase().includes(OUTDATED_APP_ERROR_MESSAGE.toLowerCase()) ||
		typedReason.name?.toLowerCase().includes(OUTDATED_APP_ERROR_NAME.toLowerCase()) ||
		typedReason.message?.toLowerCase().includes(OUTDATED_APP_CSS_ERROR_MESSAGE.toLowerCase())
	);
}

function emitShowOutdatedAppModal() {
	syncManager.emit('OUTDATED_APP', 'SHOW_MODAL');
}

export { isOutdatedAppError, emitShowOutdatedAppModal };
